import { AsyncPipe, DecimalPipe, NgIf } from '@angular/common';
import { Component, Input, OnChanges, inject } from '@angular/core';
import { AssetVersionDto, AssetVideoTypeDataDto } from '@picflow/types';
import { ThumbnailInfo, VideoThumbnailService } from 'src/app/services/video-thumbnail.service';
import { AssetVersionUrlPipe } from '../../../shared/pipes/asset-version-url.pipe';
import { FloorPipe } from '../../../shared/pipes/floor.pipe';

@Component({
  selector: 'app-video-thumbnail',
  standalone: true,
  templateUrl: './video-thumbnail.component.html',
  styleUrls: ['./video-thumbnail.component.scss'],
  imports: [FloorPipe, AssetVersionUrlPipe, NgIf, AsyncPipe, DecimalPipe],
})
export class VideoThumbnailComponent implements OnChanges {
  @Input({ required: true }) currentTime: number;
  @Input({ required: true }) assetVersion: AssetVersionDto;
  @Input() constrainWidth: boolean;
  @Input() showTime: boolean;
  loading = true;
  thumbnailInfo: ThumbnailInfo;
  private videoThumbnailService = inject(VideoThumbnailService);

  ngOnChanges(): void {
    this.getThumbnail();
  }

  private async getThumbnail() {
    this.thumbnailInfo = await this.videoThumbnailService.getThumbnail(
      this.assetVersion.uuid,
      this.assetVersion.asset_name,
      (this.assetVersion.data as AssetVideoTypeDataDto).width,
      (this.assetVersion.data as AssetVideoTypeDataDto).width,
      this.currentTime,
      (this.assetVersion.data as AssetVideoTypeDataDto).duration
    );
    this.loading = false;
  }

  public get isVertical() {
    return this.thumbnailInfo?.width < this.thumbnailInfo?.height;
  }
}
